import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '@/layouts/AppLayout';
import DashboardView from '@/views/dashboard/DashboardView';
import CardWalletView from '@/views/card-wallet/CardWalletView';
import BillingTemplatesView from '@/views/billing-templates/BillingTemplatesView';
import TransactionLogsView from '@/views/transaction-logs/TransactionLogsView';
import ProfileSettingsView from '@/views/profile/ProfileSettingsView';
import LoginView from '@/views/auth/LoginView';
import RequireAuth from '@/router/RequireAuth';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardView />} />
          <Route path="/cards" element={<CardWalletView />} />
          <Route path="/billing-templates" element={<BillingTemplatesView />} />
          <Route path="/transactions" element={<TransactionLogsView />} />
          <Route path="/profile" element={<ProfileSettingsView />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
